import { Popover } from '@headlessui/react'

export const NavigationList = ({ children }) => (
  <Popover.Group as="nav" className="hidden space-x-8 md:ml-10 md:flex py-8">
    {children}
  </Popover.Group>
)
